// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__2pR3O","checkbox_active":"Checkbox_checkbox_active__1STHc"};